import React, { Component } from 'react';
import './../../assets/css/App.css';
import { Tabs, Tab } from 'react-bootstrap';
import AdHocAccountsView from './adHocAccountsView';
import AdHocPackageView from './adHocPackageView';
import AdHocShipmentView from './adHocShipmentView';
import AdHocCouponView from './adHocCouponView';
import AdHocReferralView from './adHocReferralView';
import AdHocShipmentByStatusView from './adHocShipmentByStatusView';
import AdHocManualAccountBalanceView from './adHocManualAccountBalanceView';

class TabPanelView extends Component {
    state = {
        selectedTabKey: 1
    }

    constructor() {
        super();
    }

    handleTabSelect = (key) => {
        //alert('selected ' + key);
        this.setState({
            selectedTabKey : key
        });
    };

    render() {
        return (
            <div>
                <Tabs activeKey={this.state.selectedTabKey} onSelect={this.handleTabSelect} id="controlled-tab-example">
                    <Tab eventKey={1} title="Ad Hoc Accounts Report">
                        <AdHocAccountsView></AdHocAccountsView>
                    </Tab>
                    <Tab eventKey={2} title="Ad Hoc Package Report">
                        <AdHocPackageView></AdHocPackageView>
                    </Tab>
                    <Tab eventKey={3} title="Ad Hoc Shipment Report">
                        <AdHocShipmentView></AdHocShipmentView>
                    </Tab>
                    <Tab eventKey={5} title="Ad Hoc Coupon Report">
                        <AdHocCouponView></AdHocCouponView>
                    </Tab>
                    <Tab eventKey={6} title="Ad Hoc Referral Report">
                        <AdHocReferralView></AdHocReferralView>
                    </Tab>
                    <Tab eventKey={8} title="Ad Hoc Total Shipments by Status">
                        <AdHocShipmentByStatusView></AdHocShipmentByStatusView>
                    </Tab>
                    <Tab eventKey={9} title="Ad Hoc Manual Account Balance">
                        <AdHocManualAccountBalanceView></AdHocManualAccountBalanceView>
                    </Tab>
                </Tabs>
            </div>
        );
    }
}

export default TabPanelView;
